module.exports = __webpack_public_path__ + "img/rud.3b262688.jpg";